import React from 'react';
import { Form, Formik } from 'formik';
import { Button, Grid, SideSheet } from 'ui-toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { ILenderContactData } from '../../types/contacts/ILenderContact';
import { lenderContactFormValidation } from '../../validation/lenders/LenderContactFormValidation';
import { LenderContactForm } from './LenderContactForm';
import { EditContactFormStatusWrapper } from '../order/contacts/subComponents/EditContactFormStatusWrapper';

interface IEditLenderContactProps {
  onSubmit: (value: any) => void;
  initialData: ILenderContactData;
  onCancel: () => void;
  editFetchError?: Error;
  editFetchStatus: IFetchStatus;
}

export const EditLenderContact: React.FC<IEditLenderContactProps> = ({
  onSubmit,
  onCancel,
  editFetchError,
  editFetchStatus,
  initialData,
}) => {
  return (
    <Formik
      initialValues={initialData}
      validateOnMount={true}
      validationSchema={lenderContactFormValidation}
      onSubmit={(values) => {
        onSubmit(values);
      }}
      onReset={onCancel}
    >
      {({ isValid, dirty, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <SideSheet
            title={'Edit Contact'}
            onClose={onCancel}
            footer={
              <Grid columnCount={2}>
                <Button intent={'secondary'} type={'reset'}>
                  Cancel
                </Button>
                <Button intent={'primary'} type={'submit'} disabled={!isValid || !dirty || editFetchStatus.fetching}>
                  Save and Edit
                </Button>
              </Grid>
            }
          >
            <Grid>
              <>
                <EditContactFormStatusWrapper
                  fetching={editFetchStatus.fetching}
                  fetchError={editFetchError}
                  updateFetchedSuccess={editFetchStatus.success}
                  updateSuccessMessage={`Contact Updated!`}
                />
                <LenderContactForm disableNotEditableFields={true} />
              </>
            </Grid>
          </SideSheet>
        </Form>
      )}
    </Formik>
  );
};
